import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ConfirmDialog, useToast, Alert, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useDeleteUser } from 'app/domains/users/hooks/useDeleteUser';
export function ConfirmDeleteUserDialog(props) {
    const { id, name, onClose, navigateTo } = props;
    const [deleteUser, { loading, error }] = useDeleteUser(id);
    const { addToast } = useToast();
    const history = useHistory();
    const fallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name when user does not exist',
    });
    const username = name || fallbackName;
    const message = t({
        message: `Are you sure you want to remove ${username}?`,
        comment: 'delete user dialog message',
    });
    const handleConfirm = () => {
        deleteUser()
            .then(() => {
            addToast({ title: t `User removed`, appearance: 'success' });
            onClose();
            if (navigateTo) {
                history.push(navigateTo);
            }
        })
            .catch(() => {
            addToast({
                title: t({
                    message: 'Something went wrong, please try again later',
                    comment: 'Error alert message delete user',
                }),
                appearance: 'danger',
            });
        });
    };
    return (<ConfirmDialog appearance="danger" size="sm" loading={loading} icon={<Falcon icon="triangle-exclamation"/>} title={t `Remove`} confirm={message} cancel={t `Cancel`} onConfirm={handleConfirm} onCancel={onClose} onClose={onClose}>
      <Typography>
        <Trans>
          If you remove a user, their personal information will be permanently deleted. Any content created by the said
          user will remain on PocketLaw.
        </Trans>
      </Typography>
      {error && (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'error alert message delete user',
            })}/>)}
    </ConfirmDialog>);
}
